import { z } from 'zod';

/**
 * Runtime configuration, fetched rather than compiled in. CDK writes
 * `config.json` next to the bundle, so rotating a Cognito client or repointing
 * the API needs no rebuild of the SPA.
 *
 * For local development, copy the stack outputs into `public/config.json`.
 */
const configSchema = z.object({
  stage: z.string(),
  region: z.string(),
  apiUrl: z.string().url(),
  contentBaseUrl: z.string().url(),
  userPoolId: z.string(),
  userPoolClientId: z.string(),
  cognitoDomain: z.string().url(),
});

export type AppConfig = z.infer<typeof configSchema>;

let cached: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(
      `Could not load /config.json (${res.status}). For local development, copy the stack outputs into admin-ui/public/config.json.`,
    );
  }
  cached = configSchema.parse(await res.json());
  return cached;
}

export function getConfig(): AppConfig {
  if (!cached) throw new Error('Configuration accessed before loadConfig() resolved');
  return cached;
}
